// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"a305a8f8","326":"6bc12c3e","333":"fb89f9af","824":"e314dc04","979":"736af461"}[chunkId] + ".chunk.js";
};